// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__35at0","title":"Images45_title__3XzmM","images":"Images45_images__3buS9"};